import {Theme} from "@material-ui/core"
import createStyles from "@material-ui/core/styles/createStyles"
import makeStyles from "@material-ui/core/styles/makeStyles"
import TextField, { StandardTextFieldProps } from "@material-ui/core/TextField"
import * as React from "react"
import {SetStateAction} from "react"
import {AvantColors} from "../../../../../styles/AvantColors"
import {DateMask} from "../../../../generic-components/AvantDateRangePicker"

const NewDateInputStyles = makeStyles((theme: Theme) =>
    createStyles({
        dateRangeTextBox: {
            textAlign: "center"
        }
    })
)

export interface NewDateInputProps extends StandardTextFieldProps {
    setParentFocus: React.Dispatch<SetStateAction<boolean>>
}

export const NewDateInput: React.FC<NewDateInputProps> = ({setParentFocus, ...rest}) => {

    const classes = NewDateInputStyles()

    const textFocus = () => {
        setParentFocus(true)
    }

    /**
     * TODO: Hook up the onFocus and onBlur to allow manual date entry, these allow the focus and blur to access text
     * TODO (cont): boxes the parent component needs to prevent the opening of the date picker
     * TODO (cont): The component is disabled to prevent text entry, this will need a change for text entry
     */

    return (
        <TextField
            className={classes.dateRangeTextBox}
            // style={{fontWeight: localFocused ? "bold" : undefined}}
            name="AvantNewDateRangePicker"
            InputProps={{
                disableUnderline: true,
                // tslint:disable-next-line:no-any
                inputComponent: DateMask as any
            }}
            inputProps={{
                style: {
                    fontSize: 14,
                    color: AvantColors.REPORT_FONT_COLOR_GRAY_1
                }
            }}
            disabled={true}

            // onFocus={(event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            //     // setLocalFocused(true)
            //     // setParentFocus(true)
            //     setLocalFocus(false)
            // }}
            // onBlur={() => {
            //     // setLocalFocused(false)
            //     // setParentFocus(false)
            //     // textBlur()
            // }}
            onClick={textFocus}
            {...rest}
        />
    )
}